import {
  VOICE_PLAYBACK_RATE_MAX,
  VOICE_PLAYBACK_RATE_MIN,
  VOICE_PLAYBACK_RATE_STEP,
} from '../model/constants'

export const clampVoicePlaybackRate = (rate: number) => {
  if (!Number.isFinite(rate)) return 1

  const rounded = Math.round(rate / VOICE_PLAYBACK_RATE_STEP) * VOICE_PLAYBACK_RATE_STEP
  return Math.min(
    VOICE_PLAYBACK_RATE_MAX,
    Math.max(VOICE_PLAYBACK_RATE_MIN, Math.round(rounded * 10) / 10),
  )
}
